import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import BaseAdHubLogo from '../../../../UI/AdHubLogo/AdHubLogo';
import NavBreadcrumb from '../../../../UI/NavBreadcrumb/NavBreadcrumb';

const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 21px;
  justify-content: space-between;
  padding: 11px 15px;
`;

const AdHubLogo = styled(BaseAdHubLogo)`
  font-size: 20px;
  width: 42px;
`;

function Header() {
  const store_current = store.current;

  return (
    <Container>
      <AdHubLogo collapsed variant="black" />
      {store_current && (
        <NavBreadcrumb breadcrumbs={store_current.breadcrumbs} />
      )}
    </Container>
  );
}

export default observer(Header);
